// STYD: houdt de gravuretoeslag in de winkelwagen gekoppeld aan het sieraad.
// Bij een gravure staan er twee regels in de winkelwagen met dezelfde koppelcode (_gravure_id):
// het sieraad (met de gravuretekst) en het product 'Gravure' (_gravure_toeslag).
// Wordt het sieraad verwijderd of verandert het aantal, dan volgt de gravure automatisch.
(function () {
  if (window.stydEngravingCartReady) return;
  window.stydEngravingCartReady = true;

  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';
  let busy = false;

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      const cart = await (await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } })).json();
      const mainQuantity = {};
      const fees = [];
      cart.items.forEach((item) => {
        const props = item.properties || {};
        const token = props._gravure_id;
        if (!token) return;
        if (props._gravure_toeslag) {
          fees.push(item);
        } else {
          mainQuantity[token] = (mainQuantity[token] || 0) + item.quantity;
        }
      });

      const updates = {};
      fees.forEach((fee) => {
        const wanted = mainQuantity[fee.properties._gravure_id] || 0;
        if (fee.quantity !== wanted) updates[fee.key] = wanted;
      });
      if (!Object.keys(updates).length) return;

      const drawer = document.querySelector('cart-drawer');
      const sections =
        drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map((section) => section.id)
          : [];
      const response = await fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const result = await response.json();

      if (window.location.pathname.replace(/\/$/, '') === cartUrl().replace(/\/$/, '')) {
        // Winkelwagenpagina: opnieuw laden zodat de regels kloppen
        window.location.reload();
        return;
      }
      if (drawer && result.sections) {
        if (result.item_count === 0) drawer.classList.add('is-empty');
        drawer.getSectionsToRender().forEach((section) => {
          const html = result.sections[section.id];
          if (!html) return;
          const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }
    } catch (error) {
      // Stil falen: de winkelwagen blijft gewoon werken
    } finally {
      busy = false;
    }
  }

  function start() {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'styd-engraving') return;
        sync();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
